import React from 'react';
import { CtaButton } from './CtaButton';
type Props = {
  label: string;
  note?: string;
};
export function SectionCta({
  label,
  note
}: Props) {
  return <div className="mx-auto mt-10 flex w-full max-w-lg flex-col items-center gap-3" data-id="element-60" data-mp="5ptr4lmyvy6">
      <CtaButton data-id="element-61" data-mp="3id6ylbh898ch">{label}</CtaButton>
      <p className="text-center text-[12px] font-medium text-navy-700/70 sm:text-[13px]" data-id="element-62" data-mp="3ncjm7yfxajg4">
        {note ?? 'One-time payment of $27 USD · Automatic currency conversion · Instant download'}
      </p>
    </div>;
}